<template>
  <div>
    <OtherDocumentCard
      v-for="doc in entry.documents"
      :key="doc.id"
      :viewed-testator-id="viewedTestatorId"
      :category="entry"
      :document="doc"
      @refetch="$emit('refetch')"
      @deleted="$emit('deleted', $event)"
    />

    <v-card class="elevation-10 add-card mb-6" @click="showUpload = true">
      <div class="specific-people-info-container add-card-inner">
        <DocumentIconBadge icon="upload" tile class="mr-3" />
        <div class="flex-grow-1">
          <div class="add-title">{{ addTitle }}</div>
          <div class="add-hint">Specify a title and upload files</div>
        </div>
        <DocumentUploadButton @click="showUpload = true" />
      </div>
    </v-card>

    <UploadDocumentDialog
      v-if="showUpload"
      v-model="showUpload"
      :viewed-testator-id="viewedTestatorId"
      :document-type="entry.type"
      :document-type-display-name="entry.displayName"
      :description="entry.description"
      :requires-title="true"
      :allow-multiple-files="true"
      @uploaded="onUploaded"
    />
  </div>
</template>

<script>
  import OtherDocumentCard from './OtherDocumentCard.vue';
  import DocumentIconBadge from './DocumentIconBadge.vue';
  import UploadDocumentDialog from './UploadDocumentDialog.vue';
  import DocumentUploadButton from './DocumentUploadButton.vue';

  export default {
    name: 'OtherDocumentsList',
    components: {
      OtherDocumentCard,
      DocumentIconBadge,
      UploadDocumentDialog,
      DocumentUploadButton,
    },
    props: {
      viewedTestatorId: { type: [Number, String], required: true },
      entry: { type: Object, required: true },
    },
    data() {
      return {
        showUpload: false,
      };
    },
    computed: {
      addTitle() {
        return this.entry.documents.length
          ? 'Add another document'
          : 'Add a document';
      },
    },
    methods: {
      onUploaded() {
        this.$emit('refetch');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../constants/styles/people-overview-info-blocks.scss';
  @import '../../constants/styles/document-card.scss';

  .add-card {
    cursor: pointer;
    transition: box-shadow 0.15s;
  }
  .add-card:hover {
    box-shadow: 0 12px 24px rgba(17, 24, 39, 0.08) !important;
    @include doc-badge-hover;
  }
  .add-card-inner {
    display: flex;
    align-items: center;
  }
  .add-title {
    font-size: 14px;
    font-weight: 600;
    color: #282828;
  }
  .add-hint {
    font-size: 12px;
    color: #6b7280;
  }
</style>
